import {
  Box, Flex, Text,
} from '@chakra-ui/react';

import MyDiv from './candidateDetailsCard.style';
import { ICandidateList } from '../../OnboardCandidateList/modal';
import { showDate } from '../../../../../utilities/helper';

interface CandidateBasicDetailsProps {
  basicDetails?: ICandidateList | null;
}

const CandidateDetailsCard = ({ basicDetails }: CandidateBasicDetailsProps) => {

  return (
    <MyDiv>
      <Box className='cards' >
        <Box p={5}>
          <Text className='font-poppins text_xxl text_medium'>Basic Details</Text>
          <Flex justify="space-between" mt={4}>
            <Text className='font-poppins text_lg text_medium'>Name</Text>
            <Text className='font-poppins text_lg text_regular'>{basicDetails?.candidate_Name}</Text>
          </Flex>
          <Flex justify="space-between" mt={3}>
            <Text className='font-poppins text_lg text_medium'>Personal Email</Text>
            <Text className='font-poppins text_lg text_regular'>{basicDetails?.personal_Email}</Text>
          </Flex>
          <Flex justify="space-between" mt={3}>
            <Text className='font-poppins text_lg text_medium'>Phone Number</Text>
            <Text className='font-poppins text_lg text_regular'>{basicDetails?.phone_Number}</Text>
          </Flex>
          <Flex justify="space-between" mt={3}>
            <Text className='font-poppins text_lg text_medium'>Gender</Text>
            <Text className='font-poppins text_lg text_regular'>{basicDetails?.gender}</Text>
          </Flex>
          <Flex justify="space-between" mt={3}>
            <Text className='font-poppins text_lg text_medium'>Date of Birth</Text>
            <Text className='font-poppins text_lg text_regular'>{showDate(basicDetails?.date_of_Birth)}</Text>
          </Flex>
          <Flex justify="space-between" mt={3}>
            <Text className='font-poppins text_lg text_medium'>Date of Joining</Text>
            <Text className='font-poppins text_lg text_regular'>{showDate(basicDetails?.date_Of_Joining)}</Text>
          </Flex>
        </Box>
      </Box>
    </MyDiv>
  );
};

export default CandidateDetailsCard;